var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M15 14.5s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 13.496c.001-.264.167-1.03.76-1.72.553-.647 1.523-1.276 3.24-1.276s2.687.63 3.24 1.276c.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.78a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9.5c-4 0-5 3-5 4q0 1 1 1h4.216a2.24 2.24 0 0 1-.216-1c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816m-2.016.72a5.5 5.5 0 0 0-.92 3H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275M1.5 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
  })));
};
export default SvgUsers;